import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Fulfillment = function Fulfillment(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.4 4.1l8.17 5.6a1 1 0 0 1 .43.83v.72c0 .69-.56 1.25-1.25 1.25h-.38v7.64c0 .47-.37.86-.82.86h-.64a1 1 0 0 1-1-1v-7.5H7.1V20a1 1 0 0 1-1 1h-.63a.84.84 0 0 1-.82-.86V12.5h-.39c-.69 0-1.25-.56-1.25-1.25v-.72a1 1 0 0 1 .44-.83l8.17-5.6a.78.78 0 0 1 .79 0zM10.5 9a.5.5 0 0 0-.5.5v1c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-3zm-2 4.5h7c.28 0 .5.22.5.5v.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V14c0-.28.22-.5.5-.5zm0 2.5h7c.28 0 .5.22.5.5v.5a.5.5 0 0 1-.5.5h-7A.5.5 0 0 1 8 17v-.5c0-.28.22-.5.5-.5zm0 2.5h7c.28 0 .5.22.5.5v.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V19c0-.28.22-.5.5-.5z"
  })));
};

Fulfillment.displayName = 'Fulfillment';
export default Fulfillment;